import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cache: {}, // { "Welcome to Traineego_es": "Bienvenido a Traineego" }
};

const translationSlice = createSlice({
  name: "translation",
  initialState,
  reducers: {
    addTranslation: (state, action) => {
      const { text, lang, translated } = action.payload;
      state.cache[`${text}_${lang}`] = translated;
    },
  },
});

export const { addTranslation } = translationSlice.actions;
export default translationSlice.reducer;
